import { Pipe, PipeTransform } from '@angular/core';
import linkifyStr from 'linkifyjs/string';


@Pipe({
  name: 'textToLink',
})

export class TextToLinkPipe implements PipeTransform {
  transform(str: string): string {
    return str ? linkifyStr(str, {target: '_system'}) : str;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/text-to-link/text-to-link.ts